import dayjs from "dayjs";

export const getEnrichedRows = (rows = []) => {
  return rows.map((row) => {
    const runDate = row?.job_run_date ? dayjs(row.job_run_date) : null;

    const ageInHours = runDate?.isValid()
      ? dayjs().diff(runDate, "hour", true)
      : 0;

    const isOlderThan1Day = ageInHours > 24;

    return {
      ...row,
      ageInHours,
      isOlderThan1Day,
    };
  });
};
